import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const styles = (theme) => {
  return {
    root: {
    },
  };
};

function Banner(props) {
  const { classes } = props;
  return (<span/>)
}

export default withStyles(styles)(Banner);



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.jsx